import React from 'react';

import FavoritesListContext, {
  FavoritesListsContextValues
} from '@smart-tv/contexts/favorites-lists-context/favorites-lists-context';

export const useFavoritesLists = (): FavoritesListsContextValues => {
  const values = React.useContext(FavoritesListContext);

  return { ...values };
};

export default useFavoritesLists;
